module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAABFUlEQVR4Ab2U7Q2CMBCGjxIC/NIR6iaMoBPoBrqBuoEj6AZuoBvoBrqB/uObekeAkKZ8N75JIXCXp5e31wP4h6Io2oZhuASdiuN4j2BBK0mSNeiQ7/u8hOqCs/zB2EYOZFl2ngJnxZurggQf63kONgzj25QghOAwFpym6bMBenQc5wRjhYC5fHi4bjBBdSvuUoyDDmHLeXLV9A90CDvgrNOOSuQ1wl91ON1I0CGVJU3wwbMlCIKdokseuIFX5oyeLVjJQQGn9ZHtGgxHWzYEathAtMGNHnCOQ+qGvc6hh7ABVrZtX1lXouu6b0xc0PWGHjJNcwZDRdUrer3yng69zO20QqVitnhoj4efVOHTsqxL25TUph+tq30GM+DkmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right/6.png
// module id = ib4c
// module chunks = 25